@if (profile) {
  <div  class="flex flex-col mt-4 gap-4 md:max-w-[488px] md:m-auto">
    <div class="grid grid-cols-2 gap-4">
      <kaz-input [value]="profile.firstname" [disabled]="true" placeholder="Vorname" />
      <kaz-input [value]="profile.lastname" [disabled]="true" placeholder="Nachname" />
    </div>
    <kaz-input [value]="profile.mail" [disabled]="true" placeholder="E-Mail" />
    <kaz-input [(value)]="phone" placeholder="Telefon" inputType="number" />
    @if (phone !== profile.phone) {
      <kaz-button class="md:w-[343px] md:m-auto" (onClick)="updateSettings()" text="Speichern" />
    }
  </div>
}
